import { useNavigate, Link } from "react-router-dom";
import useLogout from "../hooks/useLogout";
import useAuth from "../hooks/useAuth";
import { Container, Row, Col, Form } from 'react-bootstrap';
import 'boxicons/css/boxicons.min.css';
import TopBar from "../pages/Admin/TopBar";
import React, { useEffect, useState, useCallback } from "react";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import "./summeryTableStyle.css"


const SthanDashboard = () => {
    const navigate = useNavigate();
    const logout = useLogout();
    const { auth } = useAuth();
    const [selectedLevelId, setSelectedLevelId] = useState("");
    const [count, setcount] = useState("");
    const [sthanList, setSthanList] = useState([]);
    const [SthanArppanSummary, setSthanArppanSummary] = useState([]);
    const axiosPrivate = useAxiosPrivate();
    const [loading, setLoading] = useState(true);

    const [error, setError] = useState(null);
    const [hasSearched, setHasSearched] = useState(false); // 👈 NEW
    const [gurudakshinas, setGurudakshinas] = useState([]);

    const signOut = async () => {
        await logout();
        navigate('/login');
    }


    const fetchSthanList = async () => {
        try {
            const response = await axiosPrivate.get('get-user-access-levels');


            // Set the default dropdown value to the first level_id if available
            if (response.data.length > 0) {
                setSthanList(response.data);
                const exists = response.data.some(item => item.level_id === auth.level_id);

                if (exists) {
                    setSelectedLevelId(auth.level_id);
                } else {
                    setSelectedLevelId(response.data[0].level_id);// Show blank dropdown
                }
                setcount(response.data.length)
            }
        } catch (error) {
            console.error("Error fetching Sthan list:", error);
        }
    };


    const fetchArppanSummary = useCallback(async () => {
        if (!selectedLevelId) return;  // 🛑 Prevent API call if undefined or empty
        setLoading(true);
        setError(null);
        setHasSearched(true);
        try {
            const url = `get-sthan-arppan-summary?sthan_id=${selectedLevelId}`;
            const response = await axiosPrivate.get(url, { withCredentials: true });
            setLoading(false);
            if (response.status === 204) {
                // ✅ No Content case
                setGurudakshinas([]);
                setLoading(false);
                setError("No Data available.");
                return;
            }

            // ✅ Handle valid data
            // setGurudakshinas(Array.isArray(response.data) ? response.data : []);
            setGurudakshinas(response.data);


        } catch (error) {
            console.error("Error fetching Data:", error);
            setError(error?.response?.data?.message || "No Data available.");
            setGurudakshinas([]); // Clear old data in case of error
            setLoading(false);
        }
    }, [axiosPrivate, selectedLevelId]);



    const summaryData = gurudakshinas?.data || [];

    const vs = summaryData.find(item => item.sakha === "Vidyarthi Samyuktha");
    const vt = summaryData.find(item => item.sakha === "Vidyarthi Tharuna");
    const vy = summaryData.find(item => item.sakha === "Vyavasayi Tharuna");
    const pr = summaryData.find(item => item.sakha === "Prouda");

    useEffect(() => {
        fetchArppanSummary();
    }, [selectedLevelId]);


    useEffect(() => {
        fetchSthanList();
    }, []);

    return (

        <Container>

            <section className="adminsec">

                {/* <div className="center-image">

                    <img src="/images/newlogo.png" width="20%" className='' />
                </div> */}
                {/* <h1 className="adminhead">Dashbord</h1> */}
                <br />
                <center><h2 className="dashwel">Namaste <span className="colorChange">{auth?.name}</span> !</h2> </center>
                <center><p className="dashwel">Welcome to <span className="colorChange">{auth?.level_name}</span> </p> </center>
                {/* <p className="adminuse">Welcome {auth?.name} !</p> */}

                <Row>
                    <Col md={3}></Col>
                    <Col md={6}>
                        <div className="">
                            <table className="dashtab">
                                <tbody>
                                    <tr>
                                        <Col className="dashnewsub" style={{ textAlign: "center" }}>
                                            <i className="bx bx-lock dashtabicon"></i> No. of Stans Assigned - {count}
                                        </Col>
                                        {/* <td className="dashsthan2">{count}</td> */}
                                    </tr>
                                </tbody>
                                {/* <tr>
                                <td className="dashsthan"><i className="bx bx-lock-open dashtabicon"></i> Signedup Sthan </td>
                                <td className="dashsthan2">18</td>
                            </tr> */}
                            </table>
                        </div>
                    </Col>
                    <Col md={3}></Col>
                </Row>
                <Row className="spclrow">
                    <Form.Group controlId="sthanDropdown" className="mb-3">
                        <Form.Label>Select Sthan</Form.Label>
                        <Form.Control
                            as="select"
                            value={selectedLevelId}
                            onChange={(e) => setSelectedLevelId(e.target.value)}
                            className="vibhaglist"
                        >
                            {sthanList.map((sthan) => (
                                <option key={sthan.level_id} value={sthan.level_id}>
                                    {sthan.level_name}
                                </option>
                            ))}
                        </Form.Control>
                    </Form.Group>
                </Row>

                <Row className="justify-content-center">
                    {hasSearched && (
                        <div className="table-container">
                            {hasSearched && (
                                <table id="customers" className="table table-bordered text-center summary-table">
                                    <thead>
                                        <tr>
                                            <th colSpan={1} className="text-center">
                                                SHRENI
                                            </th>
                                            <th colSpan={5} className="text-center">
                                                UPASTHITHI/THUKA
                                            </th>
                                        </tr>
                                        <tr>
                                            <th rowSpan={2}></th>
                                            <th>VIDHYARTHI SAMYUKTHA</th>
                                            <th>VIDHYARTHI THARUNA</th>
                                            <th>VYAVASAYI THARUNA</th>
                                            <th>PROUDA</th>
                                            <th>TOTAL</th>
                                        </tr>
                                        <tr>
                                            <th>({gurudakshinas?.vs_uthsavam ?? 0})</th>
                                            <th>({gurudakshinas?.vt_uthsavam ?? 0})</th>
                                            <th>({gurudakshinas?.vy_uthsavam ?? 0})</th>
                                            <th>({gurudakshinas?.pr_uthsavam ?? 0})</th>
                                            <th>({gurudakshinas?.uthsavam ?? 0})</th>
                                        </tr>
                                    </thead>

                                    <tbody><tr>
                                        <th>SISU</th>

                                        <td>
                                            <div>{vs?.sisu ?? 0}</div>
                                            <div className="amount">
                                                ₹{Number(vs?.sisuAmount ?? 0).toLocaleString("en-IN")}
                                            </div>
                                        </td>

                                        <td>
                                            <div> {vt?.sisu ?? 0}</div>
                                            <div className="amount">
                                                ₹{Number(vt?.sisuAmount ?? 0).toLocaleString("en-IN")}
                                            </div>



                                        </td>

                                        <td>

                                            <div> {vy?.sisu ?? 0}</div>
                                            <div className="amount">
                                                ₹{Number(vy?.sisuAmount ?? 0).toLocaleString("en-IN")}
                                            </div>


                                        </td>

                                        <td>
                                            <div> {pr?.sisu ?? 0}</div>
                                            <div className="amount">
                                                ₹{Number(pr?.sisuAmount ?? 0).toLocaleString("en-IN")}
                                            </div>



                                        </td>

                                        <td>
                                            {(vs?.sisu ?? 0) +
                                                (vt?.sisu ?? 0) +
                                                (vy?.sisu ?? 0) +
                                                (pr?.sisu ?? 0)}
                                            <br />
                                            ₹
                                            {(
                                                Number(vs?.sisuAmount ?? 0) +
                                                Number(vt?.sisuAmount ?? 0) +
                                                Number(vy?.sisuAmount ?? 0) +
                                                Number(pr?.sisuAmount ?? 0)
                                            ).toLocaleString("en-IN")}
                                        </td>
                                    </tr>
                                        <tr>
                                            <th>BALA</th>

                                            <td>
                                                {vs?.bala ?? 0}
                                                <div className="amount">
                                                    ₹{Number(vs?.balaAmount ?? 0).toLocaleString("en-IN")}
                                                </div>
                                            </td>

                                            <td>
                                                {vt?.bala ?? 0}
                                                <div className="amount">
                                                    ₹{Number(vt?.balaAmount ?? 0).toLocaleString("en-IN")}
                                                </div>
                                            </td>

                                            <td>
                                                {vy?.bala ?? 0}
                                                <div className="amount">
                                                    ₹{Number(vy?.balaAmount ?? 0).toLocaleString("en-IN")}
                                                </div>
                                            </td>

                                            <td>
                                                {pr?.bala ?? 0}
                                                <div className="amount">
                                                    ₹{Number(pr?.balaAmount ?? 0).toLocaleString("en-IN")}
                                                </div>
                                            </td>

                                            <td>
                                                {(vs?.bala ?? 0) +
                                                    (vt?.bala ?? 0) +
                                                    (vy?.bala ?? 0) +
                                                    (pr?.bala ?? 0)}
                                                <br />
                                                ₹
                                                {(
                                                    Number(vs?.balaAmount ?? 0) +
                                                    Number(vt?.balaAmount ?? 0) +
                                                    Number(vy?.balaAmount ?? 0) +
                                                    Number(pr?.balaAmount ?? 0)
                                                ).toLocaleString("en-IN")}
                                            </td>
                                        </tr>

                                        <tr>
                                            <th>VIDHYARTHI THARUNA</th>

                                            <td>
                                                {vs?.vtharuna ?? 0}
                                                <div className="amount">
                                                    ₹{Number(vs?.vtharunaAmount ?? 0).toLocaleString("en-IN")}
                                                </div>
                                            </td>

                                            <td>
                                                {vt?.vtharuna ?? 0}
                                                <div className="amount">
                                                    ₹{Number(vt?.vtharunaAmount ?? 0).toLocaleString("en-IN")}
                                                </div>
                                            </td>

                                            <td>
                                                {vy?.vtharuna ?? 0}
                                                <div className="amount">
                                                    ₹{Number(vy?.vtharunaAmount ?? 0).toLocaleString("en-IN")}
                                                </div>
                                            </td>

                                            <td>
                                                {pr?.vtharuna ?? 0}
                                                <div className="amount">
                                                    ₹{Number(pr?.vtharunaAmount ?? 0).toLocaleString("en-IN")}
                                                </div>
                                            </td>

                                            <td>
                                                {(vs?.vtharuna ?? 0) +
                                                    (vt?.vtharuna ?? 0) +
                                                    (vy?.vtharuna ?? 0) +
                                                    (pr?.vtharuna ?? 0)}
                                                <br />
                                                ₹
                                                {(
                                                    Number(vs?.vtharunaAmount ?? 0) +
                                                    Number(vt?.vtharunaAmount ?? 0) +
                                                    Number(vy?.vtharunaAmount ?? 0) +
                                                    Number(pr?.vtharunaAmount ?? 0)
                                                ).toLocaleString("en-IN")}
                                            </td>
                                        </tr>

                                        <tr>
                                            <th>VYAVASAYI THARUNA</th>

                                            <td>
                                                {vs?.tharuna ?? 0}
                                                <div className="amount">
                                                    ₹{Number(vs?.tharunaAmount ?? 0).toLocaleString("en-IN")}
                                                </div>
                                            </td>

                                            <td>
                                                {vt?.tharuna ?? 0}
                                                <div className="amount">
                                                    ₹{Number(vt?.tharunaAmount ?? 0).toLocaleString("en-IN")}
                                                </div>
                                            </td>

                                            <td>
                                                {vy?.tharuna ?? 0}
                                                <div className="amount">
                                                    ₹{Number(vy?.tharunaAmount ?? 0).toLocaleString("en-IN")}
                                                </div>
                                            </td>

                                            <td>
                                                {pr?.tharuna ?? 0}
                                                <div className="amount">
                                                    ₹{Number(pr?.tharunaAmount ?? 0).toLocaleString("en-IN")}
                                                </div>
                                            </td>

                                            <td>
                                                {(vs?.tharuna ?? 0) +
                                                    (vt?.tharuna ?? 0) +
                                                    (vy?.tharuna ?? 0) +
                                                    (pr?.tharuna ?? 0)}
                                                <br />
                                                ₹
                                                {(
                                                    Number(vs?.tharunaAmount ?? 0) +
                                                    Number(vt?.tharunaAmount ?? 0) +
                                                    Number(vy?.tharunaAmount ?? 0) +
                                                    Number(pr?.tharunaAmount ?? 0)
                                                ).toLocaleString("en-IN")}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>PROUDA</th>

                                            <td>
                                                {vs?.prouda ?? 0}
                                                <div className="amount">
                                                    ₹{Number(vs?.proudaAmount ?? 0).toLocaleString("en-IN")}
                                                </div>
                                            </td>

                                            <td>
                                                {vt?.prouda ?? 0}
                                                <div className="amount">
                                                    ₹{Number(vt?.proudaAmount ?? 0).toLocaleString("en-IN")}
                                                </div>
                                            </td>

                                            <td>
                                                {vy?.prouda ?? 0}
                                                <div className="amount">
                                                    ₹{Number(vy?.proudaAmount ?? 0).toLocaleString("en-IN")}
                                                </div>
                                            </td>

                                            <td>
                                                {pr?.prouda ?? 0}
                                                <div className="amount">
                                                    ₹{Number(pr?.proudaAmount ?? 0).toLocaleString("en-IN")}
                                                </div>
                                            </td>

                                            <td>
                                                {(vs?.prouda ?? 0) +
                                                    (vt?.prouda ?? 0) +
                                                    (vy?.prouda ?? 0) +
                                                    (pr?.prouda ?? 0)}
                                                <br />
                                                ₹
                                                {(
                                                    Number(vs?.proudaAmount ?? 0) +
                                                    Number(vt?.proudaAmount ?? 0) +
                                                    Number(vy?.proudaAmount ?? 0) +
                                                    Number(pr?.proudaAmount ?? 0)
                                                ).toLocaleString("en-IN")}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>TOTAL</th>

                                            <td>
                                                {(vs?.sisu ?? 0) +
                                                    (vs?.bala ?? 0) +
                                                    (vs?.vtharuna ?? 0) +
                                                    (vs?.tharuna ?? 0) +
                                                    (vs?.prouda ?? 0)}
                                                <br />
                                                ₹
                                                {(
                                                    Number(vs?.sisuAmount ?? 0) +
                                                    Number(vs?.balaAmount ?? 0) +
                                                    Number(vs?.vtharunaAmount ?? 0) +
                                                    Number(vs?.tharunaAmount ?? 0) +
                                                    Number(vs?.proudaAmount ?? 0)
                                                ).toLocaleString("en-IN")}
                                            </td>

                                            <td>
                                                {(vt?.sisu ?? 0) +
                                                    (vt?.bala ?? 0) +
                                                    (vt?.vtharuna ?? 0) +
                                                    (vt?.tharuna ?? 0) +
                                                    (vt?.prouda ?? 0)}
                                                <br />
                                                ₹
                                                {(
                                                    Number(vt?.sisuAmount ?? 0) +
                                                    Number(vt?.balaAmount ?? 0) +
                                                    Number(vt?.vtharunaAmount ?? 0) +
                                                    Number(vt?.tharunaAmount ?? 0) +
                                                    Number(vt?.proudaAmount ?? 0)
                                                ).toLocaleString("en-IN")}
                                            </td>

                                            <td>
                                                {(vy?.sisu ?? 0) +
                                                    (vy?.bala ?? 0) +
                                                    (vy?.vtharuna ?? 0) +
                                                    (vy?.tharuna ?? 0) +
                                                    (vy?.prouda ?? 0)}
                                                <br />
                                                ₹
                                                {(
                                                    Number(vy?.sisuAmount ?? 0) +
                                                    Number(vy?.balaAmount ?? 0) +
                                                    Number(vy?.vtharunaAmount ?? 0) +
                                                    Number(vy?.tharunaAmount ?? 0) +
                                                    Number(vy?.proudaAmount ?? 0)
                                                ).toLocaleString("en-IN")}
                                            </td>

                                            <td>
                                                {(pr?.sisu ?? 0) +
                                                    (pr?.bala ?? 0) +
                                                    (pr?.vtharuna ?? 0) +
                                                    (pr?.tharuna ?? 0) +
                                                    (pr?.prouda ?? 0)}
                                                <br />
                                                ₹
                                                {(
                                                    Number(pr?.sisuAmount ?? 0) +
                                                    Number(pr?.balaAmount ?? 0) +
                                                    Number(pr?.vtharunaAmount ?? 0) +
                                                    Number(pr?.tharunaAmount ?? 0) +
                                                    Number(pr?.proudaAmount ?? 0)
                                                ).toLocaleString("en-IN")}
                                            </td>

                                            <td>
                                                {(vs?.totalUpasthith ?? 0) +
                                                    (vt?.totalUpasthith ?? 0) +
                                                    (vy?.totalUpasthith ?? 0) +
                                                    (pr?.totalUpasthith ?? 0)}
                                                <br />
                                                ₹
                                                {(
                                                    Number(vs?.totalAmount ?? 0) +
                                                    Number(vt?.totalAmount ?? 0) +
                                                    Number(vy?.totalAmount ?? 0) +
                                                    Number(pr?.totalAmount ?? 0)
                                                ).toLocaleString("en-IN")}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            )}
                        </div>
                    )}
                </Row>
            </section>
            <TopBar />
        </Container>
    )
}

export default SthanDashboard
